import { useId } from 'react';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { DashboardPageFormBody, DashboardPageFormField } from '@shigo-ui/dashboard-ui';
import { Input, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import type { CreativeFormValue } from '../../creativeFormSchema';
import { CreativeStatus, CreativeType, resolveCreativeStatusLabel } from '../../model';
import { CreativeDisplayFields } from './CreativeDisplayFields';
import { CreativeVideoFields } from './CreativeVideoFields';

export function CreativeGeneralFields({ editMode }: { editMode: boolean }) {
  const form = useFormContext<CreativeFormValue>();
  const { errors } = useFormState({ control: form.control });
  const type = useWatch({ control: form.control, name: 'type' });
  const activeStatus = useWatch({ control: form.control, name: 'activeStatus' });
  const nameId = useId();
  const statusId = useId();

  return (
    <DashboardPageFormBody
      title={dashboardT('creatives.details')}
      description={dashboardT('creatives.detailsDescription')}
    >
      <DashboardPageFormField
        label={dashboardT('creatives.name')}
        htmlFor={nameId}
        required
        error={errors.name?.message}
      >
        <Input id={nameId} required maxLength={255} {...form.register('name')} />
      </DashboardPageFormField>
      {editMode ? (
        <DashboardPageFormField label={dashboardT('creatives.status')} htmlFor={statusId}>
          <Select
            value={activeStatus}
            onValueChange={(value) => {
              form.setValue('activeStatus', value as CreativeStatus, { shouldDirty: true });
            }}
          >
            <SelectTrigger id={statusId}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {Object.values(CreativeStatus).map((status) => (
                <SelectItem key={status} value={status}>
                  {resolveCreativeStatusLabel(status)}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </DashboardPageFormField>
      ) : null}
      {type === CreativeType.Display ? (
        <CreativeDisplayFields editMode={editMode} />
      ) : (
        <CreativeVideoFields editMode={editMode} />
      )}
    </DashboardPageFormBody>
  );
}
